import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Planning } from 'actions';
import { Header, Segment, Feature, NeuCard, ButtonFA } from 'components';
import { colors } from 'utils/colors';
import {
  PLANNING_ACCUMULATION_RETIREMENT_BLUEPRINT,
  PLANNING_ACCUMULATION_REVISIT_BLUEPRINT,
  PLANNING_ACCUMULATION_TARGET_WEALTH,
  PLANNING_ACCUMULATION_TARGET_SAVING,
} from 'utils/features';
import asset4 from 'images/asset_4.png';
import {
  faMap,
  // eslint-disable-next-line import/extensions
} from '@fortawesome/free-solid-svg-icons';

@withRouter
@connect((state) => ({
  account: state.CustomAccount.account,
}))
class Landing extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(Planning.clearStore());
  }

  render() {
    const { history } = this.props;
    return (
      <Segment expand>
        <Feature name={PLANNING_ACCUMULATION_REVISIT_BLUEPRINT}>
          <ButtonFA
            className="left"
            color={colors.orange}
            style={{
              backgroundColor: 'white',
              display: 'block',
              marginBottom: '5px',
              position: 'absolute',
              top: '2.5rem',
              right: '3.3rem',
            }}
            icon={faMap}
            onClick={() => {
              history.push(`/planning/saved-blueprints`);
            }}
          >
            See Saved Blueprints
          </ButtonFA>
        </Feature>
        <div>
          <img src={asset4} height="80" width="120" alt="Portfolio" />
          <Header size="1.5rem" color="black">
            Accumulation
          </Header>
          <P>
            Here are some simple-to-use tools to help you calculate your target
            wealth at retirement and how much you need to save in order to reach
            a particular goal, such as your children’s education or retirement.
          </P>

          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {' '}
            <Feature name={PLANNING_ACCUMULATION_RETIREMENT_BLUEPRINT}>
              <NeuCard
                to="/planning/blueprint/new/overview"
                iconName="tree"
                title="Retirement Blueprint"
                description="Let's start a new blueprint. We will help you determine your spending needs, and create a goal-oriented investing plan."
                color={colors.orange}
              />
            </Feature>
            <Feature name={PLANNING_ACCUMULATION_TARGET_WEALTH}>
              <NeuCard
                to="/planning/wealth"
                iconName="leaf"
                title="Target Wealth"
                description="Calculate your Target Wealth at retirement if you know how much you want to spend per year in retirement."
                color={colors.orange}
              />
            </Feature>
            <Feature name={PLANNING_ACCUMULATION_TARGET_SAVING}>
              <NeuCard
                to="/planning/saving"
                iconName="dollar"
                title="Target Saving"
                description="Calculate how much you need to save per month starting now to achieve your goals."
                color={colors.orange}
              />
            </Feature>
          </div>
        </div>
      </Segment>
    );
  }
}

export default Landing;

Landing.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

const P = styled.p`
  color: rgba(0, 0, 0, 0.5) !important;
  max-width: 650px;
  margin: 0 auto 3rem auto;

  &.strike {
    text-decoration: line-through;
  }
`;
